import React from 'react';

import ThemeSwitch from 'core/components/ThemeSwitch';

/**
 * @author Aleksey Rezakov <a.rezakov@rambler-co.ru>
 */
export default function withThemeSwitcher(theme) {
  return function(Component) {
    function ThemeSwitcher(props) {
      return (
        <ThemeSwitch name={theme}>
          <Component {...props} />
        </ThemeSwitch>
      );
    }

    ThemeSwitcher.WrappedComponent = Component;

    return ThemeSwitcher;
  };
}
